
import { Component, OnInit, Inject } from '@angular/core';
import { InsuranceService } from './insurance.service';
import { SearchService } from './search.service';
import { SearchRecord } from './models/searchrecord';
import { ActivatedRoute, Router } from '@angular/router';
import { WatchVideoDialog } from "./modals/watch-video.component";
import { MatDialog } from "@angular/material/dialog";
import { HealthOrganizationTypesEnum } from '../core/enums/health-organization-types.enum';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements OnInit {

  Latitude: number = null;
  Longitude: number = null;
  searchResult: SearchRecord[] = new Array<SearchRecord>();
  expandedElement: SearchRecord;
  extraInfo: any;
  locationRequired = true;
  image = 'home.png';
  selected = 0;
  interval: any;
  landing: string | null = null;
  secure: boolean;
  stable: boolean;
  scalable: boolean;
  Healthsystem: boolean;
  get healthOrganizationTypes() { return HealthOrganizationTypesEnum; }

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog
  ) {

    this.secure = false;
    this.stable = false;
    this.scalable = false;
    this.Healthsystem = false;
  }

  redirectToSignUp() {
    const redirectUrl = '/app/physician/profile/setupOrganization';
    window.location.href = `/Session/SignUp?redirectUrl=${redirectUrl}`;
  }

  contact() {
    this.router.navigate(['/appypartnercontactinfo']);
  }

  ngOnInit() {
    window.addEventListener("scroll", function () {
      var nav = document.querySelector("nav");
      nav.classList.toggle("sticky", window.scrollY > 0);
      if (window.scrollY > 0) {
        $("#my_image").attr("src", "./assets/whiteImage.png");
      }
      else {
        $("#my_image").attr("src", "assets/images/logo.png");
      }
    })
    if ('geolocation' in navigator) {
      var currentContext = this;
      // check if geolocation is supported/enabled on current browser
      navigator.geolocation.getCurrentPosition(
        function success(position) {
          // for when getting location is a success
          currentContext.Latitude = position.coords.latitude;
          currentContext.Longitude = position.coords.longitude;
          currentContext.locationRequired = false;
        },
        function error(error_message) {
          console.error('An error has occured while retrieving location', error_message);
        }
      );
    } else {
      console.log('geolocation is not enabled on this browser');
    }

    this.activeRoute.queryParams.subscribe(
      (params) => {
        if (params['phone'] && ['android', 'ios'].includes(params['phone'])) {
          this.landing = params['phone'];
        }
      },
      (error) => { console.error(error); }
    );

    this.startTimer();


    const video = <HTMLVideoElement>document.querySelector("#finalVideo");
    const playButton = document.querySelector("#videoPlay-btn");
    
    const playIcon = `<button class="playBtn"><svg fill="#FFFFFF" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17.804 17.804" xml:space="preserve"><path d="M2.067,0.043C2.21-0.028,2.372-0.008,2.493,0.085l13.312,8.503c0.094,0.078,0.154,0.191,0.154,0.313 c0,0.12-0.061,0.237-0.154,0.314L2.492,17.717c-0.07,0.057-0.162,0.087-0.25,0.087l-0.176-0.04 c-0.136-0.065-0.222-0.207-0.222-0.361V0.402C1.844,0.25,1.93,0.107,2.067,0.043z" />
     </svg></button>`;

    const pauseIcon = `<button class="playBtn"><svg height="30px" width="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 271.953 271.953" xml:space="preserve"> <path style="fill:#FFFFFF;" d="M110.707,200.114c7.511,0,13.598-6.086,13.598-13.598V83.174c0-7.511-6.086-13.598-13.598-13.598 c-7.511,0-13.598,6.086-13.598,13.598v103.342C97.109,194.028,103.195,200.114,110.707,200.114z" /><path style="fill:#FFFFFF;" d="M165.097,200.114c7.511,0,13.598-6.086,13.598-13.598V83.174c0-7.511-6.086-13.598-13.598-13.598 S151.5,75.663,151.5,83.174v103.342C151.5,194.028,157.586,200.114,165.097,200.114z" />
     </svg></button>`;
    // Event listener for the play/pause button
    playButton.addEventListener("click", function () {
      if (video.paused == true) {
        // Play the video
        video.play();

        // Update the button text to 'Pause'
        playButton.innerHTML = pauseIcon;
      } else {
        // Pause the video
        video.pause();

        // Update the button text to 'Play'
        playButton.innerHTML = playIcon;
      }
    });
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.selected++;
      if (this.selected > 6) {
        this.selected = 0;
      }
      this.setImage(this.selected);
    }, 5000);
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  setImage(id) {
    this.selected = id;
    switch (id) {
      case 1:
        this.image = 'search.png';
        break;
      case 2:
        this.image = 'discovery.png';
        break;
      case 3:
        this.image = 'careteam.png';
        break;
      case 4:
        this.image = 'benefits.png';
        break;
      case 5:
        this.image = 'request-appointment.png';
        break;
      case 6:
        this.image = 'appointments.png';
        break;
      default:
        this.image = 'home.png';
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(WatchVideoDialog, {
      id: "watch-dialog",
      width: '80%',
      hasBackdrop: true
    });

    dialogRef.afterClosed().subscribe(
      (_) => { },
      (error) => { console.error(error); }
    );
  }

  //scroll to specific elemnt
  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
    }

}


